import {
  UPDATE_REQUISITES,
  UPDATE_REQUISITES_SUCCESS,
  UPDATE_REQUISITES_FAILURE,
  ADD_REQUISITES_SUCCESS,
  ADD_REQUISITES_FAILURE,
} from '../../constants/ActionTypes';

export default function userRequisitesReducer(state, action) {
  switch (action.type) {
    case UPDATE_REQUISITES:
      return {
        ...state,
        isSending: true,
        isNotSaved: false,
        isSaved: false,
      };

    case UPDATE_REQUISITES_SUCCESS:
      return {
        ...state,
        requisites: action.payload,
        isSending: false,
        isNotSaved: false,
        isSaved: true,
      };

    case UPDATE_REQUISITES_FAILURE:
      return {
        ...state,
        errors: [...state.errors, action.error],
        isSending: false,
        isNotSaved: true,
        isSaved: false,
      };

    case ADD_REQUISITES_SUCCESS:
      return {
        ...state,
        requisites: action.payload,
      };

    case ADD_REQUISITES_FAILURE:
      return {
        ...state,
        errors: [...state.errors, action.error],
      };

    default:
      return state;
  }
}
